import React, { useEffect } from "react";
import { Box, Typography, Button, CircularProgress, Paper, Container } from "@mui/material";
import { CheckCircleOutline, ErrorOutline } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

export default function EmailVerificationAction(props) {
    const { verifyEmail, status, onContinueClicked } = props;
    const navigate = useNavigate();

    // Trigger verification on mount
    useEffect(() => {
        if (verifyEmail) {
            verifyEmail();
        }
    }, [verifyEmail]);

    let content;

    if (status === "LOADING") {
        content = (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <CircularProgress size={60} sx={{ mb: 2 }} />
                <Typography variant="h6">Verifying your email...</Typography>
            </Box>
        );
    } else if (status === "SUCCESS") {
        content = (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <CheckCircleOutline sx={{ fontSize: 60, color: 'success.main', mb: 2 }} />
                <Typography variant="h5" gutterBottom>Email Verified!</Typography>
                <Button 
                    variant="contained" 
                    fullWidth 
                    sx={{ mt: 2 }}
                    onClick={() => onContinueClicked ? onContinueClicked() : navigate("/")}
                >
                    Continue
                </Button>
            </Box>
        );
    } else {
        // INVALID_TOKEN or GENERAL_ERROR
        content = (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <ErrorOutline sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
                <Typography variant="h5" gutterBottom>Verification Failed</Typography>
                <Typography variant="body1" align="center" sx={{ mb: 2 }}>
                    The verification link is invalid or has expired.
                </Typography>
                <Button 
                    variant="contained" 
                    fullWidth 
                    onClick={() => navigate("/auth")}
                >
                    Back to Login
                </Button>
            </Box>
        );
    }

    return (
        <Container component="main" maxWidth="sm" sx={{ mt: 8 }}>
            <Paper elevation={3} sx={{ p: 4 }}>
                {content}
            </Paper>
        </Container>
    );
}
